<app-my-tabs [tabs]="tabs" [defaultTabIndex]="selMenu" (tabChange)="updateSelMenu($event)">
  <app-level-profile tab0></app-level-profile>
  <app-avatar-profile tab1 *ngIf="roleService.roles?.level?.includes('MEMBER_PROFILE_AVATAR')"></app-avatar-profile>
  <app-store-profile tab2 *ngIf="roleService.roles?.level?.includes('MEMBER_PROFILE_STORE')"></app-store-profile>
  <app-member-profile-roles tab3></app-member-profile-roles>
  <app-setting-profile tab4></app-setting-profile>
</app-my-tabs>